import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5bfd8d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=b5bfd8d0&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=b5bfd8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bfd8d0",
  null
  
)

export default component.exports